import $ from 'jquery'

const observer = new ResizeObserver(entries => entries.forEach(entry => onResize(entry.target)))

export function initialise() {
  $('[data-slider]').each((_, slider) => init(slider))
  $(document).on('click', '[data-slider-button]', event => onButtonClick(event.currentTarget))
  $(document).on('ajax.replace', event => $('[data-slider]', event.currentTarget).each((_, slider) => init(slider)))
}

function init(slider) {
  observer.observe(slider)
  $(slider).on('scroll', event => toggleButtons(event.currentTarget))
  hideButtonsIfNeeded(slider)
  toggleButtons(slider)
}

function toggleButtons(slider) {
  const sliderId = slider.getAttribute('data-slider')
  const $buttonContainer = $(`[data-slider-button-container="${sliderId}"]`)
  $('[data-slider-button="prev"]', $buttonContainer).attr('disabled', slider.scrollLeft === 0)
  $('[data-slider-button="next"]', $buttonContainer).attr(
    'disabled',
    slider.scrollLeft + slider.clientWidth === slider.scrollWidth
  )
}

function hideButtonsIfNeeded(slider) {
  const sliderId = slider.getAttribute('data-slider')
  if (slider.scrollWidth <= slider.clientWidth) {
    $(`[data-slider-button-container="${sliderId}"]`).hide()
  } else {
    $(`[data-slider-button-container="${sliderId}"]`).show()
  }
}

function onResize(slider) {
  hideButtonsIfNeeded(slider)
}

function onButtonClick(button) {
  const $buttonContainer = $(button).closest('[data-slider-button-container]')
  const sliderId = $buttonContainer.attr('data-slider-button-container')
  const $slider = $(`[data-slider="${sliderId}"]`)
  const direction = $(button).attr('data-slider-button')
  if (direction === 'next') {
    goNext($slider.get(0))
  } else {
    goPrev($slider.get(0))
  }
}

function goNext(slider) {
  const sliderX = slider.getBoundingClientRect().x
  $(slider)
    .children()
    .each((_, child) => {
      const childRect = child.getBoundingClientRect()
      if (childRect.x - sliderX > 0) {
        animateTo(slider, slider.scrollLeft + (childRect.x - sliderX))
        return false
      }
    })
}

function goPrev(slider) {
  const sliderX = slider.getBoundingClientRect().x
  $(slider)
    .children()
    .each((_, child) => {
      const childRect = child.getBoundingClientRect()
      if (childRect.right === sliderX) {
        animateTo(slider, slider.scrollLeft + (childRect.x - sliderX))
        return false
      }
    })
}

function animateTo(slider, scrollLeft) {
  $(slider)
    .css({ scrollSnapType: 'none' })
    .animate(
      { scrollLeft },
      {
        duration: 300,
        complete: () => {
          $(slider).css({ scrollSnapType: 'x mandatory' })
        },
      }
    )
}
